<template>
  <el-col :sm="12" class="modal-category">
    <base-dialog :title="$t('category.addTitle')" :openDialog="openAddDialog">
      <el-form
        :model="form"
        :rules="validator"
        ref="form"
        label-position="top"
        @submit.native.prevent
      >
        <el-row :gutter="50" class="row-input">
          <el-col :span="24">
            <el-form-item :label="$t('category.name')" prop="name">
              <el-input
                class="input"
                v-model="form.name"
                autocomplete="off"
                id="masterDataInput"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-circle-close el-input__clear"
                  @click="form.name = ''"
                  v-if="form.name"
                ></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <span class="dialog-footer">
            <el-button
              class="btn btn--cancel"
              @click="handleCloseAddDialog('form')"
            >
              {{ $t('employee.cancelBtn') }}
            </el-button>
            <el-button
              class="btn btn--submit"
              :disabled="addSubcategoryLoading"
              @click="onSubmit('form')"
            >
              {{ $t('employee.confirmBtn') }}
            </el-button>
          </span>
        </el-form-item>
      </el-form>
    </base-dialog>
  </el-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { subcategoryService } from '@/services/subcategory.service';
import { handleError, notifyMessage, redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import { maxName225 } from '@/helper/validate';

const BaseDialog = () => import('@/components/Dialog');

export default {
  name: 'AddSubcategoryDialog',
  props: {
    openAddDialog: Boolean,
  },
  components: { BaseDialog },
  data() {
    return {
      addSubcategoryLoading: false,
      form: {
        name: '',
      },
      validator: {
        name: [{ validator: maxName225, trigger: 'blur' }],
      },
    };
  },
  watch: {
    'form.name'() {
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate('name');
      }
    },
  },
  updated() {
    let inputelement = document.getElementById('masterDataInput');
    if (inputelement) {
      inputelement.focus();
    }
  },
  computed: {
    ...mapGetters('subcategory', ['subcategory']),
  },
  methods: {
    ...mapActions('subcategory', ['getSubcategoryList']),
    handleCloseAddDialog(form) {
      this.$refs[form].resetFields();
      this.$emit('handleCloseAddDialog');
    },
    onSubmit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          this.addSubcategoryLoading = true;

          return await subcategoryService
            .add(this.$router.currentRoute.params.id, this.form)
            .then(() => {
              this.getSubcategoryList({
                categoryId: this.$router.currentRoute.params.id,
                params: {
                  page: PAGE,
                  limit: LIMIT,
                },
              });

              redirectRouter({
                path: `/categories/${this.$router.currentRoute.params.id}/sub-categories`,
                query: {
                  name: undefined,
                  page: PAGE,
                },
              });
              this.$emit('handleCloseAddDialog');
              this.$refs[form].resetFields();
              notifyMessage(this.$t('common.addSuccess'), 'success');
            })
            .catch((error) => {
              handleError(error);
            })
            .finally(() => {
              this.addSubcategoryLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scope>
.modal-category {
  .el-input {
    input {
      height: 47px;
    }
  }
  .el-dialog {
    width: 620px !important;
    margin-top: 20vh !important;
  }
  @media only screen and (max-width: 768px) {
    .dialog .el-dialog {
      width: calc(80% - 20px) !important;
    }
  }
  @media only screen and (max-width: 576px) {
    .dialog .el-dialog {
      width: calc(100% - 20px) !important;
    }
  }
}
</style>
